"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.setAvailableModels = exports.setErrors = exports.setEnvVariables = exports.setCurrentActionData = exports.setActions = exports.setCurrentAgentData = exports.setAgentsList = exports.setDomainName = exports.setDomainId = void 0;
var actionTypes_1 = __importDefault(require("./actionTypes"));
function setDomainId(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_DOMAIN_ID,
            data: data,
        });
    };
}
exports.setDomainId = setDomainId;
function setDomainName(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_DOMAIN_NAME,
            data: data,
        });
    };
}
exports.setDomainName = setDomainName;
function setAgentsList(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_AGENTS_LIST,
            data: data,
        });
    };
}
exports.setAgentsList = setAgentsList;
function setCurrentAgentData(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_CURRENT_AGENT_DATA,
            data: data,
        });
    };
}
exports.setCurrentAgentData = setCurrentAgentData;
function setActions(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_ACTIONS,
            data: data,
        });
    };
}
exports.setActions = setActions;
function setCurrentActionData(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_CURRENT_ACTION_DATA,
            data: data,
        });
    };
}
exports.setCurrentActionData = setCurrentActionData;
function setEnvVariables(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_ENV_VARIABLES,
            data: data,
        });
    };
}
exports.setEnvVariables = setEnvVariables;
function setErrors(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_ERRORS,
            data: data,
        });
    };
}
exports.setErrors = setErrors;
function setAvailableModels(data) {
    return function (dispatch) {
        dispatch({
            type: actionTypes_1["default"].SET_AVAILABLE_MODELS,
            data: data,
        });
    };
}
exports.setAvailableModels = setAvailableModels;
